module.exports = __webpack_public_path__ + "img/pocket-2_en.b8e9d33.jpg";